/**
 * Channel API Contract
 *
 * Chat channels for Employment Group messaging
 */
import { oc } from "@orpc/contract";
import { z } from "zod";
import { ChannelResponseSchema, ChannelListResponseSchema, GetChannelsQuerySchema, GetChannelMessagesQuerySchema, SendChannelMessageInputSchema, } from "@hourly/api/channel";
import { MessageListResponseSchema, MarkAsReadResponseSchema } from "@hourly/api/chat";
import { uuidSchema } from "@hourly/api/validation-common";
// ============================================
// Channel Contracts
// ============================================
/**
 * GET /channels
 * List channels the user is a member of
 */
export const getChannels = oc
    .route({
    method: "GET",
    path: "/channels",
    summary: "List user's channels",
    tags: ["Channels"],
})
    .input(GetChannelsQuerySchema)
    .output(ChannelListResponseSchema);
/**
 * GET /channels/{id}
 * Get a specific channel
 */
export const getChannel = oc
    .route({
    method: "GET",
    path: "/channels/{id}",
    summary: "Get channel by ID",
    tags: ["Channels"],
})
    .input(z.object({ id: uuidSchema }))
    .output(ChannelResponseSchema);
/**
 * GET /channels/{id}/messages
 * Get messages for a channel (paginated)
 */
export const getChannelMessages = oc
    .route({
    method: "GET",
    path: "/channels/{id}/messages",
    summary: "Get messages for a channel",
    tags: ["Channels"],
})
    .input(z.object({ id: uuidSchema }).merge(GetChannelMessagesQuerySchema))
    .output(MessageListResponseSchema);
/**
 * POST /channels/{id}/messages
 * Send a message in a channel
 */
export const sendChannelMessage = oc
    .route({
    method: "POST",
    path: "/channels/{id}/messages",
    summary: "Send a message in a channel",
    tags: ["Channels"],
    successStatus: 201,
})
    .input(z.object({ id: uuidSchema }).merge(SendChannelMessageInputSchema))
    .output(z.object({ messageId: uuidSchema }));
/**
 * POST /channels/{id}/read
 * Mark channel as read
 */
export const markChannelRead = oc
    .route({
    method: "POST",
    path: "/channels/{id}/read",
    summary: "Mark channel as read",
    tags: ["Channels"],
})
    .input(z.object({ id: uuidSchema }))
    .output(MarkAsReadResponseSchema);
// ============================================
// Contract Router
// ============================================
export const channelContract = {
    getChannels,
    getChannel,
    getChannelMessages,
    sendChannelMessage,
    markChannelRead,
};
//# sourceMappingURL=channel.js.map